import { render } from "./TourHelpButton.vue?vue&type=template&id=56c40733&scoped=true"
import script from "./TourHelpButton.vue?vue&type=script&lang=js"
export * from "./TourHelpButton.vue?vue&type=script&lang=js"

import "./TourHelpButton.vue?vue&type=style&index=0&id=56c40733&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c40733"]])

export default __exports__